import { Link } from 'react-router-dom'
import { business, policies } from '../policies'
import { Logo } from './Logo'

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <Logo />
        <span>Clear routes, carefully handled.</span>
        <nav aria-label="Policies">
          {policies.map(({ slug, navLabel }) => (
            <Link key={slug} to={`/${slug}`}>{navLabel}</Link>
          ))}
        </nav>
      </div>
      <div className="site-footer__fine">
        <address>
          {business.legalName} · {business.street} · {business.cityStateZip} · {business.country}
        </address>
        <small>
          {business.brand} is a package forwarding service operated by {business.legalName}. We forward packages;
          we do not sell the products inside them. Questions: <a href={`mailto:${business.supportEmail}`}>{business.supportEmail}</a>
        </small>
        <small>© {new Date().getFullYear()} {business.legalName}. All rights reserved.</small>
      </div>
    </footer>
  )
}
